<template>
  <w-sliding-popup ref="slidingPopup" :title="detailPopupTitle" width="800px" @close="closePopup">
    <div slot="content">
      <div class="title-bar title-h4 tit">소켓 정보</div>
      <el-row :gutter="10" class="mr-b20">
        <el-col :span="12" class="list form-list">
          <el-form ref="configForm" :model="socketFormData" label-width="80px">
            <el-form-item label="호스트">
              {{getValueAfterCheckEmpty(socketFormData.host)}}
            </el-form-item>
            <el-form-item label="포트">
              {{getValueAfterCheckEmpty(socketFormData.port)}}
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12" class="list form-list">
          <el-form ref="configForm" :model="socketFormData" label-width="80px">
            <el-form-item label="포트 이름">
              {{getValueAfterCheckEmpty(socketFormData.portText)}}
            </el-form-item>
            <el-form-item label="서비스">
              {{getValueAfterCheckEmpty(socketFormData.serviceText)}}
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="title-bar title-h4 tit">스택 트레이스</div>
      <el-input readonly type="textarea" v-model="stackContent" :rows="33"></el-input>
    </div>
  </w-sliding-popup>
</template>

<script>
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WSocketStackTracePopup',
  props: {
    socketInfo: {
      type: Object,
    },
  },
  data() {
    return {
      stackContent: '',
      detailPopupTitle: '',
      socketFormData: {},
    };
  },
  watch: {
    socketInfo: {
      handler() {
        if (Object.entries(this.socketInfo).length > 0) {
          this.socketFormData = this.socketInfo;
          this.stackContent = this.socketInfo.stack;
          this.detailPopupTitle = `[${this.socketInfo.host}] 상세 정보`;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getValueAfterCheckEmpty,
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/apm/socket/popup/SocketStackTracePopup.vue